import { Button, Typography, CircularProgress } from '@mui/material';
import axios from 'axios';
import React, { useState } from 'react';

function SendNoti() {
  const [sendingCusto, setSendingCusto] = useState(false);
  const [sendingProf, setSendingProf] = useState(false);

  const sendNotification = () => {
    if (sendingCusto) return;
    setSendingCusto(true);

    //axios.get("https://httpbin.org/get")
    axios.get("https://laravelapi.bidit.co.il/api/sendwhatsAppmessage?type=custo")
      .then(res => {
        window.location.href = "https://www.bidit.co.il/admin/home";
      })
      .catch(err => {
        console.log(err);
        setSendingCusto(false);
      });
  };

  const sendNotificationProf = () => {
    if (sendingProf) return;
    setSendingProf(true);

    //axios.get("https://httpbin.org/get")
    axios.get("https://laravelapi.bidit.co.il/api/sendwhatsAppmessage?type=prof")
      .then(res => {
        window.location.href = "https://www.bidit.co.il/admin/home";
      })
      .catch(err => {
        console.log(err);
        setSendingProf(false);
      });
  };

  return (
    <div style={{ marginTop: "30px", marginBottom: "30px" }}>
      <Typography variant='h5'>Send Whatsapp Message to the customers</Typography>

      <Button
        sx={{ mt: 5, mb: 5 }}
        variant='contained'
        disabled={sendingCusto}
        onClick={sendNotification}
      >
        {sendingCusto ? (
          <>
            <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
            Sending...
          </>
        ) : (
          "Send Message"
        )}
      </Button>

      <Typography variant='h5'>Send Whatsapp Message to the professionals</Typography>

      <Button
        sx={{ mt: 5, mb: 5 }}
        variant='contained'
        disabled={sendingProf}
        onClick={sendNotificationProf}
      >
        {sendingProf ? (
          <>
            <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
            Sending...
          </>
        ) : (
          "Send Message"
        )}
      </Button>
    </div>
  );
}

export default SendNoti;
